export default function Hero() {
  const stats = [
    { value: '10万+', label: '影视资源' },
    { value: '每日更新', label: '最新剧集' },
    { value: '高清流畅', label: '不缓冲' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[640px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20atmosphere%20with%20soft%20golden%20amber%20lighting%2C%20abstract%20film%20projection%20concept%2C%20dark%20rich%20crimson%20and%20deep%20brown%20tones%2C%20elegant%20movie%20streaming%20vibe%2C%20minimalist%20composition%2C%20warm%20glow%20effect%2C%20no%20text%2C%20cinematic%20mood%2C%20photorealistic%20render%2C%20cozy%20yet%20premium%20feel&width=1600&height=1000&seq=hero-bg-farmer-movie&orientation=landscape"
          alt="农民影视高清影视在线观看背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-500/20 text-primary-200 border border-primary-400/30 backdrop-blur-sm mb-5">
              海量资源 · 即点即播
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              农民影视 · 免费高清影视在线观看
            </h1>

            <p className="text-base md:text-lg text-white/75 font-medium mb-6">
              高清电影免费看，电视剧免费全集，不缓冲不卡顿
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              农民影视是一个专业的免费高清影视在线观看平台，汇聚海量高清电影和电视剧免费全集资源，涵盖动作、喜剧、爱情、科幻、悬疑等全类型内容。每日持续更新最新影视作品，采用领先的流媒体传输技术，即点即播无需等待，尽享影视盛宴。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs text-white/55 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-base"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/20 rounded-lg font-medium text-sm transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                <i className="ri-fire-line text-base"></i>
                浏览排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20experience%20concept%2C%20golden%20film%20reel%20with%20digital%20streaming%20interface%20elements%2C%20warm%20amber%20and%20crimson%20gradient%20lighting%2C%20elegant%20home%20theater%20visualization%2C%20modern%20minimalist%20design%2C%20movie%20poster%20aesthetic%2C%20rich%20dark%20warm%20atmosphere%2C%20professional%20cinematography%20style%2C%20high%20detail%20render&width=1200&height=800&seq=hero-visual-movie&orientation=landscape"
                alt="农民影视高清电影免费看体验"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full shadow-lg">
                  <i className="ri-play-fill text-white text-lg"></i>
                </div>
                <div className="flex-1 bg-white/15 backdrop-blur-md rounded-lg h-2 overflow-hidden">
                  <div className="h-full w-3/5 bg-primary-500 rounded-lg"></div>
                </div>
                <span className="text-white/80 text-xs whitespace-nowrap">HD 1080P</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}